import styled from "styled-components";
import Layout_user from "../../../Component/UI/Layout_user";
import { Icon, RowView2 } from "../../../Component/style/common_style";
import { useNavigate } from "react-router-dom";
import TopBar from "../../../Component/UI/TopBar";
import WithdrawModal from "./Modal/WithdrawModal";
import { useState } from "react";
import Footer from "../../../Component/UI/Footer";
import InquiryModal from "./Modal/InquiryModal";

const Help = () => {
  const [withdrawModalVisible, setWithdrawModalVisible] = useState(false);
  const handleWithdrawModal = () => {
    setWithdrawModalVisible(!withdrawModalVisible);
  };
  const [inquiryModalVisible, setInquiryModalVisible] = useState(false);
  const handleinquiryModalVisible = () => {
    setInquiryModalVisible(!inquiryModalVisible);
  };

  const refreshToekn = localStorage.getItem("key") || null;

  return (
    <Layout_user>
      <TopBar title={"고객센터"} />
      <MenuListDiv>
        <MenuItem onClick={handleinquiryModalVisible}>
          <Icon
            src={require("../../../Image/ic_chat_white.png")}
            style={{ marginRight: 5 }}
          />
          <div>시스템 문의</div>
        </MenuItem>
        <Bar />
        {refreshToekn && (
          <MenuItem onClick={handleWithdrawModal}>
            <Icon
              src={require("../../../Image/ic_people_white.png")}
              style={{ marginRight: 5 }}
            />
            <div>회원탈퇴</div>
          </MenuItem>
        )}
      </MenuListDiv>
      <WithdrawModal
        visible={withdrawModalVisible}
        handleModal={handleWithdrawModal}
      />
      <InquiryModal
        visible={inquiryModalVisible}
        handleModal={handleinquiryModalVisible}
      />
      <Footer />
    </Layout_user>
  );
};
export default Help;

const MenuListDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 60%;
  padding: 20px;
  font-family: var(--font-Pretendard-SemiBold);
  font-size: 16px;
`;

const MenuItem = styled(RowView2)`
  padding: 24px 0px;
  cursor: pointer;
`;

const Bar = styled.div`
  width: 100%;
  height: 1px;
  background-color: #555555;
`;
